
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/texas",
      function () {
        return require("private-next-pages/medical-card/texas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/texas"])
      });
    }
  